export const baseReviewabilityDefaults = {
  hubSpotter: null,
  portalReviewsCount: 0,
  portalEmployeeSize: null,
  portalMarketplaceIndustry: null,
  userAlreadyReviewed: null,
  userOnProviderPortal: null,
  testPortal: null,
  maxPortalReviews: 0
};